import { Box } from "@mui/material";
import React, { useEffect } from "react";
import Sidebar from "../../components/SidebarLayout/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import SupportMasterContent from "../../components/Masters/SupportMaster/SupportMasterContent";
import { getSupportMasterList } from "../../redux/actions/mastersAction";

const SupportMaster = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSupportMasterList());
  }, []);
  return (
    <>
      <Sidebar activeTab="Masters" title="Masters">
        <Box className="globalContainer_For_Content">
          <SupportMasterContent />
        </Box>
      </Sidebar>
    </>
  );
};

export default SupportMaster;
